import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {Link, useHistory} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Confirm from "v4/components/ui/Confirm/Confirm";
import {QUOTE_DELETE} from "v4/data/apiRoutes";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useToggle from "v4/hooks/useToggle";
import useDeleteEntity from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/hooks/useDeleteEntity";
import TableLink from "v4/components/utils/TableLink/TableLink";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import {resolveUrl} from "v4/features/front/navigation/utils/route.utils";
import PdfButton from "v4/features/front/generatePdf/components/PdfButton/PdfButton";
import {getQuotePdfFiles} from "v4/utils/quotePdfFiles";

export default function ProspectQuotesCustomTabRowActions({rowId, onDuplicate, isSplit, files, name, updateHandler}) {
    const {t} = usePolTranslation();
    const [isConfirmOpen, toggleConfirmOpen] = useToggle();
    const deleteContact = useDeleteEntity(QUOTE_DELETE, rowId, toggleConfirmOpen);
    const {push} = useHistory();
    const {currentRoute, getRouteByNativeIdentifier} = useNavigation();

    const handleRelaunch = () => {
        const taskRoute = getRouteByNativeIdentifier('detail_open_tasks');
        const prospectId = currentRoute?.params?.prospect;

        if (taskRoute?.url && prospectId) {
            const resolvedPath = resolveUrl(taskRoute.url, {prospect: prospectId});
            push({
                pathname: `/${resolvedPath}/add`,
                state: {relaunchId: rowId}
            });
        }
    };

    return (
        <>
            <TableLink href={({pathname}) => `${pathname}/${rowId}`}/>
            <ul className="table-actions">
                <li className={`table-actions__pdf ${getQuotePdfFiles(files).length > 0 ? 'has-dropdown' : ''}`}>
                    <PdfButton variant="listing"
                               files={files}
                               quoteId={rowId}
                               quoteName={name}
                               updateHandler={updateHandler}/>
                </li>
                <li data-for="row-action" data-tip={t('edit')}>
                    <Link to={({pathname}) => `${pathname}/${rowId}/edit`}>
                        <PolIcon icon="edit"/>
                    </Link>
                </li>
                <li onClick={!isSplit ? onDuplicate(rowId) : undefined} data-for="row-action" data-tip={t('duplicate_action_quote')} data-disabled={isSplit}>
                    <PolIcon icon="copy"/>
                </li>
                <li onClick={!isSplit ? handleRelaunch : undefined} data-for="row-action" data-tip={t('recovery_action_quote')} data-disabled={isSplit}>
                    <PolIcon icon="file-export-solid"/>
                </li>
                <li data-for="row-action" data-tip={t('delete')}>
                    <PolIcon icon="trash" onClick={toggleConfirmOpen}/>
                </li>
            </ul>
            <ReactTooltip id="row-action" effect="solid"/>
            <Confirm title={t('delete')}
                     isOpen={isConfirmOpen}
                     cancelAction={toggleConfirmOpen}
                     confirmAction={deleteContact}>
                <p>{t('popup_validation_suppression')}</p>
            </Confirm>
        </>
    )
}
